import React, { useEffect } from 'react';
import { Loader2Icon } from 'lucide-react';
interface ExternalRedirectProps {
  to: string;
}

/** Sends the visitor to another website (e.g. ecc-longcovid.com). */
export function ExternalRedirect({
  to
}: ExternalRedirectProps) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-5 text-center text-muted" data-id="element-99" data-mp="1n4d2hz0cqjpp">
      <Loader2Icon className="h-6 w-6 animate-spin text-primary" aria-hidden="true" data-id="element-100" data-mp="2atnw8wjabduc" />
      <p className="text-sm" data-id="element-101" data-mp="2fqxt2x906rs7">
        U wordt doorgestuurd naar{' '}
        <a href={to} className="font-medium text-primary hover:underline" data-id="element-102" data-mp="21szf3sylgxd8">
          {to.replace(/^https?:\/\//, '').replace(/\/$/, '')}
        </a>
      </p>
    </div>;
}